import { Alert } from '@mui/material/index';
import { DataGrid } from '@mui/x-data-grid';
import { isEmpty, noop } from 'lodash';
import PropTypes from 'prop-types';

// eslint-disable-next-line complexity
const DataTable = ({
  // eslint-disable-next-line react/prop-types
  columns = [],
  // eslint-disable-next-line react/prop-types
  rows = [],
  currentPage = 0,
  setCurrentPage = noop,
  hideFooter = false,
  onPaginationChange = noop,
  pageSize = 0,
  setPageSize = noop,
  // eslint-disable-next-line no-magic-numbers
  pageSizeOptions = [5, 10, 20, 30],
  totalRowCount = 0,
}) => {
  const handlePaginationModelChange = (paginationModel) => {
    setCurrentPage(paginationModel.pageSize === pageSize ? paginationModel.page : 0);

    setPageSize(paginationModel.pageSize);
    onPaginationChange();
  };

  if (isEmpty(rows)) {
    return (
      <Alert variant="outlined" severity="info">
        No available data to display.
      </Alert>
    );
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <DataGrid
        columns={columns}
        rows={rows}
        pageSizeOptions={pageSizeOptions}
        hideFooter={hideFooter}
        pagination
        disableColumnFilter
        disableRowSelectionOnClick
        paginationMode="server"
        rowCount={totalRowCount}
        getRowId={(row) => row._id}
        paginationModel={{
          page: currentPage,
          pageSize,
        }}
        onPaginationModelChange={handlePaginationModelChange}
        getRowHeight={() => 'auto'}
      />
    </div>
  );
};

DataTable.propTypes = {
  currentPage: PropTypes.number,
  setCurrentPage: PropTypes.func,
  hideFooter: PropTypes.bool,
  pageSize: PropTypes.number,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  setPageSize: PropTypes.func,
  totalRowCount: PropTypes.number,
  onPaginationChange: PropTypes.func,
};

export default DataTable;
